import * as yup from 'yup'

const ExtrasValidator = yup.object({   
  
    coupon: yup.string(),
})

export { ExtrasValidator }